
import { toast } from "sonner";

export function usePhoneNumberValidation() {
  const validatePhoneNumber = (phoneNumber: string) => {
    if (!phoneNumber) {
      toast.error("Please enter a phone number");
      return false;
    }

    // Basic validation - check if it's at least 10 digits
    const digitsOnly = phoneNumber.replace(/\D/g, '');
    if (digitsOnly.length < 10) {
      toast.error("Please enter at least 10 digits for your phone number");
      return false;
    }

    return true;
  };

  const formatPhoneNumber = (phoneNumber: string) => {
    const digitsOnly = phoneNumber.replace(/\D/g, '');
    
    // If it's a 10-digit number, assume US/Canada and add +1
    if (digitsOnly.length === 10) {
      return `+1${digitsOnly}`;
    }
    
    // If it already includes country code (11+ digits), just add +
    if (digitsOnly.length >= 11) {
      return `+${digitsOnly}`;
    }
    
    return digitsOnly;
  };

  return {
    validatePhoneNumber,
    formatPhoneNumber
  };
}
